import { Button as AntButton, Modal } from "antd";
import { FC } from "react";
import { useTranslation } from 'react-i18next';
import StudentPoint from "../../../student/student/Point";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  classCode: string|undefined;
  memberCode: string;
}

const PointDetailModal: FC<IProps> = ({
  visible,
  setVisible,
  classCode,
  memberCode,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        title={t('class.class.title13')}
        visible={visible}
        width={750}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton key="cancel" className='btn-basic pink' onClick={() => setVisible(false)}>
              {t('common.button.confirm')}
            </AntButton>
          </div>
        ]}
      >
        <StudentPoint
          memberCode={memberCode}
          defaultClassCode={classCode}
        />
      </Modal>    
    </>
  );
}

export default PointDetailModal;
